module.exports = __webpack_public_path__ + "img/category-24px.003052c2.svg";